import React from 'react';
import { useState } from 'react';
import NextICon from '../../images/icons/next.svg'
import PrevICon from '../../images/icons/prev.svg'
import './FormFieldsStyle.css'
const Table = (props) => {

    const data = props.item && props.item.text && JSON.parse(props.item.text);
   
const [scrollPosition,setScrollPosition] = useState(0)
console.log("tableprops",scrollPosition);
const scrollLeft=()=>{
    const tableEl = document.getElementById("tableCTA")
    if(scrollPosition>0){
    let tempOffSet = scrollPosition
setScrollPosition(tempOffSet-=50);
tableEl.scrollTo({
    
        top: 0,
        left: scrollPosition - 50,
        behavior: 'smooth'
      
})
}
}
const scrollRight=()=>{
const tableEl = document.getElementById("tableCTA")
if( scrollPosition <450){
    let tempOffSet = scrollPosition
setScrollPosition(tempOffSet+=50);
tableEl.scrollTo({
    
        top: 0,
        left: scrollPosition + 50,
        behavior: 'smooth'
      
})
}
}


    return (
        <div className="table-responsive" id="tableCTA">
        <p className="bold">Set Top Box Transaction History</p>
        
            <table className="table table-bordered">
                  <tbody>
                    <tr>
                    {data.headers && data.headers.map(i => (
                    <th style={{padding:'12px'}}>{i}</th>
                ))}
                    </tr>
                    {data.data && data.data.map(i => (
                <tr>
                    {i.map(item => (
                        <td style={{padding:'3px 5px',fontSize:'14px',color:"#444444"}}>{item}</td>
                    ))}
                </tr>
            ))}
                  </tbody>
                </table>
                <div className='scroller-table'>
           { <img src={PrevICon} style={{opacity:scrollPosition <50 ?0:1}} onClick={()=>scrollLeft()}></img>}
           {  <img style={{opacity: scrollPosition < 450 ?1:0}} src={NextICon} onClick={()=>scrollRight()}></img>}
        </div>
        </div>
    )
}


export default Table;